import { Grid, ListCard, ListCardRow, Mono, OrgAvatar, Progress, StatCard, StatCardGroup, Text } from "@athena/ui";
import React from "react";
import { useTranslation } from "react-i18next";

export interface OrgCompletionStat {
    id: string;
    name: string;
    total: number;
    completed: number;
}

interface AssignmentOverviewProps {
    course?: { description?: string | null };
    totalAssigned: number;
    completed: number;
    inProgress: number;
    overdue: number;
    completionByOrg: OrgCompletionStat[];
}

export const AssignmentOverview: React.FC<AssignmentOverviewProps> = ({
    totalAssigned,
    completed,
    inProgress,
    overdue,
    completionByOrg,
}) => {
    const { t } = useTranslation();

    const pct = (count: number) =>
        totalAssigned > 0 ? `${Math.round((count / totalAssigned) * 100)}% of assigned` : "—";
    return (
        <Grid cols={1}>
            <StatCardGroup className="w-full">
                <StatCard label={"Total assignments"} value={totalAssigned} />
                <StatCard label={"Completed"} value={completed} detail={pct(completed)} detailColor="green" />
                <StatCard label={"In progress"} value={inProgress} detail={pct(inProgress)} detailColor="yellow" />
                <StatCard label="Overdue" value={overdue} detail="Past due date" />
            </StatCardGroup>
            <Grid cols={1}>
                <ListCard
                    title={t("admin.lms.completionByOrg")}
                    action={<Mono size="xs">{completionByOrg.length} assigned</Mono>}
                >
                    {completionByOrg.map((org) => {
                        const orgPct = org.total > 0 ? Math.round((org.completed / org.total) * 100) : 0;
                        return (
                            <ListCardRow
                                key={org.id}
                                className="grid grid-cols-[auto_minmax(0,1fr)_minmax(0,2fr)_auto_auto] items-center gap-4"
                            >
                                <OrgAvatar id={org.id} fallback={org.name.slice(0, 2).toUpperCase()} size="sm" />
                                <Text size="sm" weight="semibold" className="truncate" title={org.name}>
                                    {org.name}
                                </Text>
                                <Progress value={orgPct} />
                                <Mono muted className="w-8 text-right text-xs tabular-nums">
                                    {org.total}
                                </Mono>
                                <Mono className="w-12 text-right text-sm font-bold tabular-nums">{orgPct}%</Mono>
                            </ListCardRow>
                        );
                    })}
                </ListCard>
            </Grid>
        </Grid>
    );
};
